import React from 'react';
import './Pagination.css';

const WINDOW_SIZE = 5;

/** Paginación numérica con ventana deslizante, primera y última página.
 *  Mismo comportamiento que el explorador de carpetas, pero reutilizable.
 *  `page` es 1-based. */
const Pagination = ({ page, totalPages, totalItems, itemLabel = 'elementos', loading = false, onChange }) => {
  if (totalPages <= 1) return null;

  const half = Math.floor(WINDOW_SIZE / 2);
  let start = Math.max(1, page - half);
  const end = Math.min(totalPages, start + WINDOW_SIZE - 1);
  start = Math.max(1, end - WINDOW_SIZE + 1);

  const pages = [];
  for (let i = start; i <= end; i += 1) pages.push(i);

  const go = (target) => {
    const clamped = Math.max(1, Math.min(target, totalPages));
    if (clamped !== page && !loading) onChange(clamped);
  };

  return (
    <div className="pager">
      <div className="pager-controls">
        <button className="pager-nav" onClick={() => go(page - 1)} disabled={page === 1 || loading}>
          <span className="pager-arrow">‹</span> Anterior
        </button>

        {start > 1 && (
          <>
            <button className="pager-page" onClick={() => go(1)} disabled={loading}>1</button>
            {start > 2 && <span className="pager-ellipsis">…</span>}
          </>
        )}

        {pages.map((p) => (
          <button
            key={p}
            className={`pager-page ${p === page ? 'active' : ''}`}
            onClick={() => go(p)}
            disabled={loading}
          >
            {p}
          </button>
        ))}

        {end < totalPages && (
          <>
            {end < totalPages - 1 && <span className="pager-ellipsis">…</span>}
            <button className="pager-page" onClick={() => go(totalPages)} disabled={loading}>{totalPages}</button>
          </>
        )}

        <button className="pager-nav" onClick={() => go(page + 1)} disabled={page >= totalPages || loading}>
          Siguiente <span className="pager-arrow">›</span>
        </button>
      </div>

      {totalItems !== undefined && (
        <span className="pager-info">{totalItems.toLocaleString('es-ES')} {itemLabel}</span>
      )}
    </div>
  );
};

export default Pagination;
